
import axios from 'axios'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Selector from 'vux/src/components/selector/index.vue'
import InlineXNumber from 'vux/src/components/inline-x-number/index.vue'

import { Debounce } from '../utils'
import Bus from '../bus'
import Disclaimer from './Disclaimer'
export default {
name:'AddFormOther',
directives: {
TransferDom
},
components:{
TransferDom, XDialog, Group, XInput, XTextarea, XButton, Flexbox, FlexboxItem, Toast, Grid, GridItem, Selector,InlineXNumber,Disclaimer
},
props:['showmodal','type','billOtherId'],
watch:{
billOtherId(v){
this.queryDate(v)
},
showmodal(v){
var el = document.getElementById('app')
this.scrollTop = v ? document.documentElement.scrollTop : this.scrollTop
el.hidden = v
if (!v) {
setTimeout(() => {
window.scrollTo({top:this.scrollTop||0, left:0})
}, 200)
}
}
},
data(){
return {
originatorNameText:'',
acceptNameText:'',
materialNameText:'',
entNameText:'',
supplierEnterpriseName: '',
supplierName: '',
supplierPhone: '',
supplierLocation: '',
name:'',
location:'',
enterpriseName:'',
phone:'',
nameIcon:'',
orgnameIcon:'',
locationIcon:'',
phoneIcon:'',
isToast: false,
toastMsg: '提交成功',
toastType: 'success',
systemId: '',
details:[],
positionimg2: require('../assets/2.png'),
telphone:''
}
},
methods:{
setIconType (v, icon) {
if (v == "") {
this[icon] = "error"
} else {
this[icon] = "success"
}
},
submit: Debounce(function () {

const _this = this;
if (this.enterpriseName == "") {
this.orgnameIcon = "error"
return
}
if (this.location == "") {
this.locationIcon = "error"
return
}
if (this.name == "") {
this.nameIcon = "error"
return
}
if (this.phone == "") {
this.phoneIcon = "error"
this.toastMsg = `必填`
this.toastType = "text"
return
}
/* if (this.materialDes == "") {
this.isToast = true

this.toastType = "text"
return
} */
var detailslist = this.details.map(function(v){
return {
materialClassName:v.materialClassName,
materialDesc:v.materialDesc,
executedNum:v.materialNum,
materialNum:v.field1,
price:v.price
}
})
axios.post('/yuncai-yop/contribute/save', {
supplierEnterpriseName: this.supplierEnterpriseName,
supplierName: this.supplierName,
supplierPhone: this.supplierPhone,
supplierLocation: this.supplierLocation,
enterpriseName: this.enterpriseName,
name: this.name,
phone: this.phone,
location: this.location,
details: detailslist,
sourceId: this.billOtherId,
systemId: this.systemId,
type:this.type
}).then(function (res) {
_this.isToast = true
_this.toastMsg = "提交成功"
_this.toastType = "success"
Bus.$emit("close-modal",!_this.showmodal)
console.log(res)
}).catch((function (err) {
console.log(err)
_this.isToast = true
_this.toastMsg = "提交失败"
_this.toastType = "warn"
}))
}, 3000),
queryDate (id) {
axios.get('/yuncai-yop/contribute/detail?id=' + id).then(response => {
if (response.data && response.data.status == 1) {
var res = response.data.data
this.name = res.name
this.location = res.location
this.enterpriseName = res.enterpriseName
this.phone = res.phone
this.supplierEnterpriseName = res.supplierEnterpriseName
this.supplierName = res.supplierName
this.supplierPhone = res.supplierPhone
this.supplierLocation = res.supplierLocation
this.details = res.details
this.telphone = "tel:"+res.phone
}
})
},
close () {
Bus.$emit("close-modal",!this.showmodal)
},
toastHide () {
if (this.toastType !== "text") {
this.supplierEnterpriseName = ''
this.supplierName = ''
this.supplierPhone = ''
this.supplierLocation = ''
}
},
},
mounted () {
var tag = window.location.search.split('=')[1]
if(tag && tag.includes('hzh')){

this.systemId = 1
}else{

this.systemId = 0
}

switch(this.type){
case 5:
this.originatorNameText = '申请募捐人信息'
this.acceptNameText = '定向捐赠人信息'
this.materialNameText = '申请募捐物资信息'
this.entNameText = '捐赠人'
break;
case 7:
this.originatorNameText = '捐赠人信息'
this.acceptNameText = '受赠人信息'
this.materialNameText = '捐赠物资信息'
this.entNameText = '募捐方'
break;
case 9:
this.originatorNameText = '供货人信息'
this.acceptNameText = '采购人信息'
this.materialNameText = '供应物资信息'
this.entNameText = '需求方'
break;
case 11:
this.originatorNameText = '采购人信息'
this.acceptNameText = '供货人信息'
this.materialNameText = '采购物资信息'
this.entNameText = '需求方'
break;
}


}
}



// WEBPACK FOOTER //
// ./src/components/AddFormOther.vue